import { get } from './common';

export default {
    getPageContent: async (params, token) => get(`/v1/Auction/GetContentLinkHTML?key=${params.key}`, token),
}